import { Pipe, PipeTransform } from '@angular/core';
import { CandidatStatusOnMission } from '../utils/enums';

@Pipe({
  name: 'candidatMissionStatus',
})
export class CandidatMissionStatusPipe implements PipeTransform {
  transform(value: string, ...args: unknown[]): unknown {
    switch (value) {
      case CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION:
        return 'Candidature en attente';
      case CandidatStatusOnMission.CANCELED_BY_ESTABLISHMENT:
        return 'Annulé par etablissement';
      case CandidatStatusOnMission.ACCEPTED:
        return 'Candidature acceptée : contrat en attente de votre signature';
      case CandidatStatusOnMission.REJECTED:
        return 'Candidature refusée';
      case CandidatStatusOnMission.ACCEPTED_AND_SIGNED_BY_BOTH:
        return 'Candidature acceptée et contrat signé par les deux parties';
      case CandidatStatusOnMission.PAYMENT_DONE:
        return 'Payé';
      case CandidatStatusOnMission.WAITING_FOR_ESTABLISHMENT_VALIDATION:
        return 'En attente de validation par l’établissement';
      case CandidatStatusOnMission.MISSION_VALIDATED_WAITING_FOR_PAYMENT:
        return 'Mission validée en attente de paiement';
      case CandidatStatusOnMission.ARCHIVED:
        return 'Archivé';
      case CandidatStatusOnMission.NEUTRAL:
        return 'Publiée en attente';
      case CandidatStatusOnMission.RESERVED:
        return 'Réservé';
      case CandidatStatusOnMission.VALIDATION_REJECTED_BY_ESTABLISHMENT:
        return 'Validation refusée';
      case CandidatStatusOnMission.CANCELED_BY_CANDIDATE:
        return 'Annulé par vous';
      // Acceptée côté établissement, contrat pas encore envoyé par l'agence : pour le pro la candidature reste « en attente »
      case CandidatStatusOnMission.CONTRACT_PENDING_VALIDATION:
        return 'Candidature en attente';
      case CandidatStatusOnMission.CANCELED_BY_INTERIM_AGENCY:
        return 'Annulée par l’agence';
      case CandidatStatusOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT:
        return "Acceptation d'annulation en cours après signature de contrat par les deux parties";
      case CandidatStatusOnMission.CANCELLATION_ACCEPTED_AFTER_SIGNING:
        return 'Annulée par vous même après signature de contrat par les deux parties';
      default:
        return 'Publiée en attente';
    }
  }
}
